/**
 * main.js
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Components
import App from "./App.vue";
import "@/styles/explanation-inline-images.scss";

// Composables
import { createApp } from "vue";
import { getFunctions, httpsCallable } from "firebase/functions";

// Plugins
import { registerPlugins } from "@/plugins";

import * as Sentry from "@sentry/vue";
import { configureAdminDraftApprovalDiagnosticSender } from "@/utils/adminDraftApprovalDiagnostics.mjs";

const app = createApp(App);

Sentry.init({
  app,
  dsn: "https://2c9c634ed9422c2b401acf39ccc2e1a9@o4509153061634048.ingest.de.sentry.io/4509153062879312",
  integrations: [Sentry.replayIntegration()],
  // Session Replay
  replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

registerPlugins(app);

const recordAdminDraftApprovalDiagnostic = httpsCallable(
  getFunctions(undefined, "europe-west2"),
  "adminRecordDraftApprovalDiagnostic",
);
configureAdminDraftApprovalDiagnosticSender((payload) =>
  recordAdminDraftApprovalDiagnostic(payload),
);

app.mount("#app");
